import { useEffect } from 'react';
import { SESSION_COUPON_CODE } from '../Auth';

type Props = {
  applyCoupon: ({ couponCode }: { couponCode: string }) => void;
  appliedCouponCode?: string;
};
export const useSessionBasedCouponRedemption = ({ applyCoupon, appliedCouponCode }: Props) => {
  const storedCouponCode = localStorage.getItem(SESSION_COUPON_CODE);

  useEffect(() => {
    if (appliedCouponCode) {
      localStorage.removeItem(SESSION_COUPON_CODE);
    }
    if (storedCouponCode) {
      applyCoupon({ couponCode: storedCouponCode });
    }
  }, [appliedCouponCode, applyCoupon, storedCouponCode]);
};
